import { useFormik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { generateInvoiceSchema } from "../../../lib/validations/generateInvoiceValidations";
import { generateInvoice } from "../../../apis/generateInvoiceApi";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function GenerateInvoice() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: generateInvoiceSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const res = await generateInvoice(values);
        
        if (res?.result || res?.success) {
          formik.resetForm();
          alert("Invoice generated successfully");
        } else {
          alert(res?.message || "Error generating invoice");
          console.error("Error generating invoice:", res);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Error generating invoice. Please try again.");
        setLoading(false);
      }
    },
  });

  const backClick = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px", cursor: "pointer" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                {/* Email Field */}
                <TextInputFormik 
                  label="Email" 
                  field="email" 
                  formik={formik}
                  type="email"
                  placeholder="Enter email address"
                />

                {/* Generate button or loading spinner */}
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "50px", padding: "7px 30px" }}
                  >
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <button className="btn btn-primary" type="submit">
                    Generate Invoice
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

